export const updateAssessmentAction = assessment => {
  return {
    type: 'UPDATE_ASSESSMENT',
    data: assessment,
  };
};
